import React from 'react';
import {FaCheck, FaExclamation} from "react-icons/fa";

const IconCellRender = ({value}) => {
    const handleIcons = (value) =>{
        const status = JSON.parse(value).status;
        if (status === "OK"){
            return <FaCheck style={{ color: '#47A447' }}/>
        }

        if (status === "OK !"){
            return <>
                <FaCheck style={{ color: '#47A447' }}/>
                <FaExclamation style={{ color: '#EAB313' }}/>
            </>
        }

        if (status === "!"){
            return <FaExclamation style={{ color: '#EAB313' }}/>
        }

    }

    return (
        <div className={"flex justify-center w-full"}>
            {handleIcons(value)}
        </div>
    );
};

export default IconCellRender;